import React, { useCallback, useState, Fragment } from 'react';
import { isNil } from 'lodash';
import Button from '../../../../../components/Button';
import CountOfTotal from '../../../../../components/CountOfTotal';
import BaseForm from '../../../../../components/form/BaseForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Select from '../../../../../components/input/Select/Select';
import Panel from '../../../../../components/outline/Panel';
import {
  MINIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT,
  MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_MEMO,
  MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT,
  RECOMMEND_SEARCH_WORD_TYPE_SELECT_LIST,
  RECOMMEND_SEARCH_WORD_TYPE,
} from '../../../../../constants/service/app/recommendSearchWordConstants';
import { asyncSimpleModal } from '../../../../../lib/common';
import recommendSearchWordSearchInfo from '../../../../../static/images/recommend/searchWord/recommend-search-word-search-info.png';
import recommendSearchWordPopularTopInfo from '../../../../../static/images/recommend/searchWord/recommend-search-word-popular-top-info.png';
import RecommendSearchInfoDrawer from '../../../common/RecommendSearchInfoDrawer';
import './RecommendSearchWordSaveInfo.scss';

const RecommendSearchWordSaveInfo = (props) => {
  const { form, setData, recommendSearchWordInfo, typeDisabled } = props;
  const { type, memo } = recommendSearchWordInfo;

  const [drawerVisible, setDrawerVisible] = useState(false);

  const toggleDrawerVisible = useCallback(async () => {
    if (isNil(type)) {
      await asyncSimpleModal({
        title: '추천 검색 키워드 타입',
        type: 'error',
        message: '먼저 추천 검색 키워드 타입을 선택해주세요.',
      });

      return;
    }

    setDrawerVisible(!drawerVisible);
  }, [drawerVisible, type]);

  return (
    <Panel className="recommend-search-word-save-info">
      <div className="panel-header">
        <div className="title">추천 검색 키워드 정보</div>
        <Button isRadius color="primary" text="설명보기" onClick={toggleDrawerVisible} />
      </div>

      <div className="panel-body">
        {/* 추천 검색 키워드 타입 */}
        <BaseForm
          label="추천 타입"
          content={
            <Select
              list={RECOMMEND_SEARCH_WORD_TYPE_SELECT_LIST}
              onChange={(value) =>
                setData({
                  path: ['recommendSearchWordSave', 'recommendSearchWordInfo', 'type'],
                  value,
                })
              }
              defaultValue={type}
              value={type}
              disabled={typeDisabled}
              isTable={false}
            />
          }
        />

        {/* 메모 */}
        <TextAreaForm
          form={form}
          label={
            <span>
              메모
              <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_MEMO} />
            </span>
          }
          initialValue={memo}
          maxLength={MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_MEMO}
          onChange={(value) =>
            setData({
              path: ['recommendSearchWordSave', 'recommendSearchWordInfo', 'memo'],
              value,
            })
          }
          name="memo"
          autoSize={{ minRows: 4, maxRows: 8 }}
        />
      </div>

      <RecommendSearchInfoDrawer
        title="추천 검색 키워드"
        visible={drawerVisible}
        onClose={toggleDrawerVisible}
        imgUrl={
          type === RECOMMEND_SEARCH_WORD_TYPE.POPULAR_POP
            ? recommendSearchWordPopularTopInfo
            : recommendSearchWordSearchInfo
        }
      >
        <Fragment>
          <div>*앱에서 검색 키워드 검색 탭에서 추천되는 검색 키워드 리스트입니다.</div>
          {type === RECOMMEND_SEARCH_WORD_TYPE.POPULAR_POP ? (
            <div>
              앱 검색화면에 노출되는 인기 검색어는 무조건 {MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT[type]}개로
              설정을 하셔야 합니다.
            </div>
          ) : (
            <div>
              *추천 검색 키워드 리스트는 최소 {MINIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT[type]}개, 최대{' '}
              {MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT[type]}개입니다.{' '}
            </div>
          )}
        </Fragment>
      </RecommendSearchInfoDrawer>
    </Panel>
  );
};

export default RecommendSearchWordSaveInfo;
